module.exports = __webpack_public_path__ + "static/media/Amoonguss_gaussian2.5c0413be.png";